module.exports = __webpack_public_path__ + "static/img/07@2x.7f24ffc3.png";